<header>
  <span [hidden]="true"> {{eLProducts}}</span>
  <div class="wrap-lg nav-header">
    <div class="head-inner">
      <div class="head-left">
        <!-- <div (click)="util.route('home'); util.clearInstitudeData()" class="logo-sec"> -->
          <div (click)="iconRefresh()" class="logo-sec">
          <img src="assets/images/logo.png" id="logo" alt="Logo" />
        </div>
      </div>
      <nav *ngIf="!util.isMobile">
        <div class="cus-dropdown-hover nav-item" *ngIf="util.getCache('ishome')" (mouseenter)="mouseEnter()">
          Educational Loans
          <div id="menu_el_drop" class="drop-content">
            <div class="drop-item" (click)="loadProduct(cat, eLProducts)" *ngFor="let cat of eLProducts.category">
              <img width="24" [src]="util.getImageFromBase64(cat.image64)" alt="School Fees" /> {{cat.name}}
            </div>
          </div>
        </div>
        <div class="cus-dropdown-hover nav-item">
          Resources
          <div id="menu_resource_drop" class="drop-content">
            <!-- <div class="drop-item">Newsletters</div>
            <div class="drop-item">Blogs</div> -->
            <div class="drop-item" (click)="util.route('faq')">FAQs</div>
            <div class="drop-item" (click)="util.route('emiCalculator')">EMI Calculator</div>
          </div>
        </div>
        <div class="cus-dropdown-hover nav-item">
          Company
          <div id="menu_company_drop" class="drop-content">
            <div class="drop-item" (click)="util.route('contactUs')">Contact Us</div>
            <div class="drop-item" (click)="util.route('grievanceRedressal')">Grievance Redressal</div>
            <div class="drop-item" (click)="util.route('privacy')">Privacy Policy</div>
          </div>
        </div>
      </nav>
      <!-- Mobile Nav -->
      <nav *ngIf="util.isMobile && util.getCache('ishome')">
        <div class="nav-item" [class.active]="mobMenutab == 'home'" (click)="mobMenutab = 'home';util.route('home')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g id="vuesax/bulk/home">
              <g id="home">
                <path class="nav_fill_1" id="Vector" d="M10.07 2.8201L3.14002 8.37009C2.36002 8.99009 1.86002 10.3001 2.03002 11.2801L3.36002 19.2401C3.60002 20.6601 4.96002 21.8101 6.40002 21.8101H17.6C19.03 21.8101 20.4 20.6501 20.64 19.2401L21.97 11.2801C22.13 10.3001 21.63 8.99009 20.86 8.37009L13.93 2.83008C12.86 1.97008 11.13 1.9701 10.07 2.8201Z" fill="#DDE2E3"/>
                <path class="nav_fill_2" id="Vector_2" d="M12 15.5C13.3807 15.5 14.5 14.3807 14.5 13C14.5 11.6193 13.3807 10.5 12 10.5C10.6193 10.5 9.5 11.6193 9.5 13C9.5 14.3807 10.6193 15.5 12 15.5Z" fill="#ffffff"/>
              </g>
            </g>
          </svg>
          Home
        </div>
        <div class="nav-item" [class.active]="mobMenutab == 'loans'" (click)="mobMenutab = 'loans';showMenu($event)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g id="coin">
              <g id="coin_2">
                <path class="nav_fill_1" id="Vector" d="M9.99 17.98C14.4028 17.98 17.98 14.4028 17.98 9.99C17.98 5.57724 14.4028 2 9.99 2C5.57724 2 2 5.57724 2 9.99C2 14.4028 5.57724 17.98 9.99 17.98Z" fill="#DDE2E3"/>
                <path class="nav_fill_2" id="Vector_2" d="M21.97 15.9901C21.97 19.2901 19.29 21.9701 15.99 21.9701C13.95 21.9701 12.16 20.9501 11.08 19.4001C15.44 18.9101 18.91 15.4401 19.4 11.0801C20.95 12.1601 21.97 13.9501 21.97 15.9901Z" fill="#DDE2E3"/>
                <g id="Group 772544539">
                  <g id="Vector_3">
                    <path class="nav_fill_1" d="M12.998 7.1875H7.79688H9.21538C9.71699 7.1875 10.1981 7.38677 10.5528 7.74146C10.9074 8.09615 11.1067 8.57722 11.1067 9.07884C11.1067 9.58045 10.9074 10.0615 10.5528 10.4162C10.1981 10.7709 9.71699 10.9702 9.21538 10.9702H7.79688L10.6339 13.8072" fill="#DDE2E3"/>
                    <path class="nav_stroke_2" d="M12.998 7.1875H7.79688H9.21538C9.71699 7.1875 10.1981 7.38677 10.5528 7.74146C10.9074 8.09615 11.1067 8.57722 11.1067 9.07884C11.1067 9.58045 10.9074 10.0615 10.5528 10.4162C10.1981 10.7709 9.71699 10.9702 9.21538 10.9702H7.79688L10.6339 13.8072" stroke="white" stroke-width="1.10328" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <path class="nav_stroke_2" id="Vector_4" d="M7.79688 9.08105H12.998" stroke="white" stroke-width="1.10328" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
              </g>
            </g>
          </svg>
          Loans
        </div>
        <div class="nav-item" [class.active]="mobMenutab == 'resources'" (click)="mobMenutab = 'resources';showMenu($event)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g id="Group 772548104">
              <g id="vuesax/twotone/search-normal">
                <g id="search-normal">
                  <path class="nav_stroke_1 nav_fill_1" id="Vector" d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z" stroke="#DDE2E3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path class="nav_stroke_1" id="Vector_2" d="M22.7499 22.7499L19.5 19.5" stroke="#DDE2E3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
              </g>
              <g id="vuesax/bulk/profile">
                <g id="profile">
                  <path class="nav_fill_2" id="Vector_3" d="M11.6933 5C9.94664 5 8.52664 6.42 8.52664 8.16667C8.52664 9.88 9.86664 11.2667 11.6133 11.3267C11.6666 11.32 11.72 11.32 11.76 11.3267C11.7733 11.3267 11.78 11.3267 11.7933 11.3267C11.8 11.3267 11.8 11.3267 11.8066 11.3267C13.5133 11.2667 14.8533 9.88 14.86 8.16667C14.86 6.42 13.44 5 11.6933 5Z" fill="#DDE2E3"/>
                  <path class="nav_fill_2" id="Vector_4" d="M15.08 13.0999C13.22 11.8599 10.1867 11.8599 8.31333 13.0999C7.46667 13.6666 7 14.4333 7 15.2533C7 16.0733 7.46667 16.8333 8.30667 17.3933C9.24 18.0199 10.4667 18.3333 11.6933 18.3333C12.92 18.3333 14.1467 18.0199 15.08 17.3933C15.92 16.8266 16.3867 16.0666 16.3867 15.2399C16.38 14.4199 15.92 13.6599 15.08 13.0999Z" fill="#DDE2E3"/>
                </g>
              </g>
            </g>
          </svg>
          Resources
        </div>
        <div class="nav-item" [class.active]="mobMenutab == 'company'" (click)="mobMenutab = 'company';showMenu($event)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g id="vuesax/bulk/buildings">
              <g id="buildings">
                <path class="nav_fill_2" id="Vector" d="M10 19V8H5C3 8 2 9 2 11V19C2 21 3 22 5 22H13C11 22 10 21 10 19ZM6.75 17C6.75 17.41 6.41 17.75 6 17.75C5.59 17.75 5.25 17.41 5.25 17V13C5.25 12.59 5.59 12.25 6 12.25C6.41 12.25 6.75 12.59 6.75 13V17Z" fill="#DDE2E3"/>
                <path class="nav_fill_1" id="Vector_2" d="M14 22H13C11 22 10 21 10 19V5C10 3 11 2 13 2H19C21 2 22 3 22 5V19C22 21 21 22 19 22H18" fill="#DDE2E3"/>
                <path id="Vector_3" d="M18 18V22H14V18C14 17.45 14.45 17 15 17H17C17.55 17 18 17.45 18 18Z" fill="white"/>
                <g id="Group">
                  <path class="nav_fill_2" id="Vector_4" d="M14 13.75C13.59 13.75 13.25 13.41 13.25 13V8C13.25 7.59 13.59 7.25 14 7.25C14.41 7.25 14.75 7.59 14.75 8V13C14.75 13.41 14.41 13.75 14 13.75Z" fill="white"/>
                </g>
                <g id="Group_2">
                  <path class="nav_fill_2" id="Vector_5" d="M18 13.75C17.59 13.75 17.25 13.41 17.25 13V8C17.25 7.59 17.59 7.25 18 7.25C18.41 7.25 18.75 7.59 18.75 8V13C18.75 13.41 18.41 13.75 18 13.75Z" fill="white"/>
                </g>
              </g>
            </g>
          </svg>
          Company
        </div>
      </nav>
      <div class="head-right" [class.menu-arrange]="!util.getCache('ishome')">
        <button  *ngIf="isShowLogin" (click)="!util.isUserLoggedIn? util.route('login') :util.showDialog()" class="btn-primary logout">
          <svg *ngIf="util.isUserLoggedIn" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M5.12812 3.02688C5.27801 2.95949 5.4484 2.95385 5.60241 3.01117C5.75642 3.06849 5.88166 3.18416 5.95102 3.33314C6.02037 3.48212 6.02826 3.65242 5.97298 3.80718C5.91769 3.96193 5.80368 4.08869 5.65562 4.16C4.75179 4.57939 4.01827 5.29486 3.5765 6.18797C3.13473 7.08108 3.0112 8.09828 3.22635 9.07117C3.4415 10.0441 3.98244 10.9143 4.75962 11.5379C5.53679 12.1614 6.5036 12.5008 7.5 12.5C8.49511 12.5001 9.46049 12.1608 10.2368 11.5381C11.013 10.9155 11.5538 10.0468 11.7697 9.07542C11.9857 8.10403 11.8639 7.08803 11.4246 6.19516C10.9852 5.30229 10.2545 4.58595 9.35313 4.16438C9.2059 4.09234 9.09287 3.96534 9.03838 3.81076C8.98389 3.65618 8.9923 3.48638 9.06181 3.33794C9.13131 3.1895 9.25635 3.07431 9.40997 3.01718C9.5636 2.96005 9.73352 2.96555 9.88313 3.0325C10.8521 3.48536 11.6718 4.20521 12.246 5.10755C12.8202 6.0099 13.1251 7.05731 13.125 8.12687C13.125 11.2325 10.6062 13.75 7.5 13.75C4.39375 13.75 1.875 11.2325 1.875 8.12687C1.87479 7.05514 2.18089 6.00567 2.75725 5.1021C3.3336 4.19853 4.1562 3.47851 5.12812 3.02688ZM7.5 1.25C7.65308 1.25002 7.80084 1.30622 7.91523 1.40795C8.02963 1.50967 8.10271 1.64984 8.12063 1.80187L8.125 1.875V6.25C8.12482 6.4093 8.06383 6.56252 7.95447 6.67836C7.84511 6.79419 7.69565 6.8639 7.53663 6.87323C7.3776 6.88257 7.22101 6.83083 7.09886 6.72858C6.9767 6.62634 6.89819 6.48131 6.87937 6.32312L6.875 6.25V1.875C6.875 1.70924 6.94085 1.55027 7.05806 1.43306C7.17527 1.31585 7.33424 1.25 7.5 1.25Z" fill="#98A4AB"/>
          </svg>  
          {{!util.isUserLoggedIn? 'Login' : 'Logout'}}
        </button>
        <button class="btn-theme" *ngIf="util.getCache('ishome') && isShowLogin" (click)="searchVisible = true; searchValue=''">Apply Now</button>
        
      </div>
    </div>
  </div>
</header>

<p-dialog [(visible)]="util.popupVisible || permissionDialog || dialogpermission.show" (visibleChange)="util.popupVisible = $event" [modal]="true" styleClass="cus-dialog-md cus-dialog {{permissionDialog || dialogpermission.show? 'permissionDialog':'logout-dialog'}}" [draggable]="false" [closable]="!permissionDialog && !dialogpermission.show" [resizable]="false">
  <div class="logout-inner" *ngIf="!permissionDialog && !dialogpermission.show">
    <div class="left">
      <img src="assets/images/logout_img.svg" alt="logout"/>
    </div>
    <div class="right">
      <div class="logout-title">Leave NorthernArc?</div>
      <div class="logout-info">Are you sure you <span class="highlight">want to logout ?</span></div>
      <div class="logout-action">
        <button class="btn-secondary" (click)="util.popupVisible = false">No</button>
        <button class="btn-primary" (click)="logout()">Yes</button>
      </div>
    </div>
  </div>
  <div class="permission-content" *ngIf="permissionDialog || dialogpermission.show">
      <h1>{{dialogpermission.title || 'Permissions Denied'}}</h1>
      <div class="content">
        <!-- <p class="sub-heading">
          Please follow the steps
        </p> -->
        <p>{{dialogpermission.contentText || "Please go to your browser's settings and allow NorthernArc to access location services."}}</p>
        <!-- <p>2. Click allow NorthernArc access your location.</p>
        <p>3. Click done.</p> -->
      </div>
      <!-- <button class="btn-primary" (click)="requestLocation()">Allow</button> -->
  </div>
</p-dialog>

<p-dialog [(visible)]="searchVisible" (onShow)="inputField.focus()" [modal]="true" styleClass="cus-dialog-md cus-dialog search-dialog" [draggable]="false" [resizable]="false">
  <div class="search-dialog-content">
    <h1>Search for your School/Institute</h1>
    <div class="cus-dropdown" >
      <div class="page-search-1">
        <input type="text" [(ngModel)]="searchValue" #inputField (input)="searchCourse($event)" (click)="searchCourse($event)" class="cus-input" placeholder="Search your school/institute"/>
        <svg class="search-icon" width="48" height="40" viewBox="0 0 48 40" fill="none" >
          <path d="M3.08964 10.2988C1.54977 5.16589 5.39334 0 10.7522 0H40C44.4183 0 48 3.58172 48 8V32C48 36.4183 44.4183 40 40 40H17.9522C14.4194 40 11.3048 37.6827 10.2896 34.2988L3.08964 10.2988Z" fill="#17151C"/>
          <path d="M27.6 27.2C31.7974 27.2 35.2 23.7974 35.2 19.6C35.2 15.4026 31.7974 12 27.6 12C23.4026 12 20 15.4026 20 19.6C20 23.7974 23.4026 27.2 27.6 27.2Z" stroke="#10D7EE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M36.0002 28L33.2002 25.2" stroke="#10D7EE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div  *ngIf="loading" >
        <app-loader [isshow]="true"></app-loader>
      </div>
      <div id="page_search" *ngIf="searchData" class="drop-content open">
        <div class="drop-item" (click)="selectCourse(data)" *ngFor="let data of searchData.content">{{data.name}}</div>
      </div>
      <div  *ngIf="this.noDataFound && !this.loading " >
         <app-no-results></app-no-results>
      </div>
      

      <!-- <div class="drop-content">
        <div class="drop-item">Company 1</div>
        <div class="drop-item">Company 2</div>
        <div class="drop-item">Company 3</div>
        <div class="drop-item">Company 4</div>
        <div class="drop-item">Company 5</div>
        <div class="drop-item">Company 6</div>
        <div class="drop-item">Company 7</div>
        <div class="drop-item">Company 8</div>
        <div class="drop-item">Company 9</div>
        <div class="drop-item">Company 10</div>
        <div class="drop-item">Company 11</div>
      </div> -->
    </div>
  </div>
</p-dialog>
<div id="mob_menu_sec" class="mob-menu-sec" (click)="stopProp($event)">
  <ng-container *ngIf="mobMenutab == 'loans'">
    <div class="mob-loan-list">
      <div class="mob-sec-title">Educational Loans</div>
      <div class="loan-item" (click)="loadProduct(cat, eLProducts)" *ngFor="let cat of eLProducts.category; index as i;">
        <div class="ico-sec" [ngClass]="{
          one: i === 0, 
          two: i === 2, 
          three: i === 1,
          four: i === 3
        }">
          <img [src]="util.getImageFromBase64(cat.image64)" [alt]="cat.name" />
        </div>
        <div class="det-sec">
          <div class="loan-name">{{cat.name}}</div>
          <div class="loan-desc">{{cat.tag_line}}</div>
        </div>
        <img class="arrow-img" src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/>
      </div>
      <!-- <div class="loan-item">
        <div class="ico-sec two">
          <img src="assets/images/home/menu_career_upgrade.svg" alt="Career Upgradation" />
        </div>
        <div class="det-sec">
          <div class="loan-name">Career Upgradation</div>
          <div class="loan-desc">For different coaching classes like JEE, Medical etc</div>
        </div>
        <img class="arrow-img" src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/>
      </div>
      <div class="loan-item">
        <div class="ico-sec three">
          <img src="assets/images/home/menu_skill_development.svg" alt="Skill Development" />
        </div>
        <div class="det-sec">
          <div class="loan-name">Skill Development</div>
          <div class="loan-desc">For all the skill development courses</div>
        </div>
        <img class="arrow-img" src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/>
      </div>
      <div class="loan-item">
        <div class="ico-sec four">
          <img src="assets/images/home/menu_coaching_fee.svg" alt="Coaching Fee Loan" />
        </div>
        <div class="det-sec">
          <div class="loan-name">Coaching Fee Loan</div>
          <div class="loan-desc">For online courses like Upgrad, Coursera etc </div>
        </div>
        <img class="arrow-img" src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/>
      </div> -->
    </div>
  </ng-container>
  <ng-container *ngIf="mobMenutab == 'resources'">
    <div class="mob-menu-list">
      <div class="mob-sec-title">Resources</div>
      <div class="list-item" (click)="util.route('faq'); hideMenu($event)">
        <img src="assets/images/icons/mob_menu_faq.svg" alt="" />FAQ's
        <img class="arrow-img" src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/>
      </div>
      <div class="list-item" (click)="hideMenu($event) ;util.route('emiCalculator');">
        <img src="assets/images/icons/mob_menu_emi.svg" alt=""  />EMI Calculator
        <img class="arrow-img" src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="mobMenutab == 'company'">
    <div class="mob-menu-list">
      <div class="mob-sec-title">Company</div>
      <div class="list-item" (click)="util.route('contactUs'); hideMenu($event)">
        <img src="assets/images/icons/mob_menu_contact.svg" alt=""    />Contact Us
        <img class="arrow-img" src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/>
      </div>
      <div class="list-item" (click)="util.route('grievanceRedressal'); hideMenu($event)">
        <img src="assets/images/icons/mob_menu_grievance.svg" alt=""   />Grievance Redressal
        <img class="arrow-img" src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/>
      </div>
      <div class="list-item" (click)="util.route('privacy'); hideMenu($event)" >
        <img src="assets/images/icons/mob_menu_privacy.svg" alt=""  />Privacy Policy
        <img class="arrow-img" src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/>
      </div>
      <div class="list-item" *ngIf="util.isUserLoggedIn" (click)="util.popupVisible = true; hideMenu($event)" >
        <img src="assets/images/icons/mob_menu_logout.svg" alt="" />Logout
        <img class="arrow-img" src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/>
      </div>
    </div>
  </ng-container>
</div>
